// Khai báo cột cho ba tab CRM — nguồn duy nhất cho header, column picker và CSV.
//
// `mac_dinh: false` = có cột nhưng tắt sẵn: ID chỉ để tra cứu và link sang tab
// khác, bật hết là bảng không đọc nổi.
//
// `khoaLink` = cột này là key trỏ sang bản ghi khác; bấm vào mở panel bên phải.
//
// `kieu` quyết định cách vẽ chữ:
//   'id'  font đơn cách, chuỗi số dài mới đọc và so sánh được
//   'so'  chữ số dạng bảng, ngày giờ và số đếm thẳng cột
// Không gán `kieu` = văn bản thường. Ép chữ số dạng bảng lên tên và ghi chú thì
// khoảng cách chữ giãn ra, đọc rất cứng.

// toLocaleString('vi-VN') tra ve "09:05:03 8/8/2026": gio dung truoc ngay, co
// giay, va KHONG dem so 0 - nen "8/8" voi "18/08" lech cot du da tabular-nums.
// Tu dinh dang: ngay truoc, bo giay, dem du hai chu so -> moi dong rong bang
// nhau. Nam bo khoi bang (o `title` va file CSV van co du).
const hai = n => String(n).padStart(2, '0');

const gio = giatri => {
  if (!giatri) return '';
  const d = new Date(giatri);
  return `${hai(d.getDate())}/${hai(d.getMonth() + 1)} ${hai(d.getHours())}:${hai(d.getMinutes())}`;
};

const gioDay = giatri => {
  if (!giatri) return '';
  const d = new Date(giatri);
  return `${hai(d.getDate())}/${hai(d.getMonth() + 1)}/${d.getFullYear()} ${hai(d.getHours())}:${hai(d.getMinutes())}:${hai(d.getSeconds())}`;
};

export const TAB = ['khach', 'ad', 'inbox'];

// --- Tab Khách hàng: một row = một contact -------------------------------
//
// CHỈ giữ dữ kiện của KHÁCH và khoá trỏ đi. Tên campaign, tài khoản QC, các id
// của cây quảng cáo đã có nguyên tab Ad — lặp lại ở đây là 20 cột không ai đọc
// hết, mà vẫn phải cuộn ngang. Bấm AD_ID là panel bung ra đủ.
// Cần ghép file chi phí thì xuất CSV từ tab Ad rồi nối theo ad_id.
export const COT_KHACH = [
  { khoa: 'name', nhan: 'HO_TEN', mac_dinh: true, lay: h => h.fb.name },
  {
    khoa: 'phone_number',
    nhan: 'SDT',
    mac_dinh: true,
    lay: h => h.fb.phone_number,
  },
  { khoa: 'age', nhan: 'TUOI', mac_dinh: false, lay: h => h.fb.age },
  { khoa: 'gender', nhan: 'GIOI_TINH', mac_dinh: false, lay: h => h.fb.gender },
  {
    khoa: 'fb_id',
    kieu: 'id',
    nhan: 'FB_ID',
    mac_dinh: false,
    lay: h => h.ads.fb_id,
  },
  {
    khoa: 'ad_id',
    kieu: 'id',
    nhan: 'AD_ID',
    mac_dinh: true,
    khoaLink: 'ad',
    lay: h => h.ads.ad_id,
  },
  {
    khoa: 'occurred_at',
    kieu: 'so',
    nhan: 'LUC_BAM',
    mac_dinh: true,
    lay: h => gio(h.ads.occurred_at),
    layCsv: h => gioDay(h.ads.occurred_at),
  },
  {
    khoa: 'touch_count',
    kieu: 'so',
    nhan: 'SO_LAN_CHAM',
    mac_dinh: false,
    lay: h => h.ads.touch_count,
  },
  {
    khoa: 'conversation_id',
    kieu: 'so',
    nhan: 'HOI_THOAI',
    mac_dinh: true,
    khoaLink: 'inbox',
    lay: h => h.inbox.conversation_id,
  },
  {
    khoa: 'agents',
    nhan: 'AGENT_REP',
    mac_dinh: true,
    lay: h => (h.inbox.agents || []).join(', '),
  },
  {
    khoa: 'last_activity_at',
    kieu: 'so',
    nhan: 'HOAT_DONG',
    mac_dinh: true,
    lay: h => gio(h.inbox.last_activity_at),
    layCsv: h => gioDay(h.inbox.last_activity_at),
  },
  {
    khoa: 'inbox_name',
    nhan: 'TRANG',
    mac_dinh: false,
    lay: h => h.inbox.inbox_name,
  },
  {
    khoa: 'the',
    nhan: 'THE',
    mac_dinh: true,
    lay: h => (h.inbox.labels || []).join(', '),
  },
  // Ghi chú đứng CUỐI: nội dung dài và không cố định, để giữa bảng thì mọi cột
  // sau nó bị đẩy đi mỗi dòng một khác.
  {
    khoa: 'ghi_chu',
    nhan: 'GHI_CHU',
    mac_dinh: true,
    dai: true,
    lay: h => (h.fb.notes || []).join(' | '),
  },
];

// --- Tab Ad: một row = một quảng cáo -------------------------------------
export const COT_AD = [
  {
    khoa: 'ad_id',
    kieu: 'id',
    nhan: 'AD_ID',
    mac_dinh: true,
    khoaLink: 'ad',
    lay: a => a.ad_id,
  },
  {
    khoa: 'campaign_name',
    nhan: 'CHIEN_DICH',
    mac_dinh: true,
    lay: a => a.campaign_name,
  },
  {
    khoa: 'adset_name',
    nhan: 'NHOM_QC',
    mac_dinh: false,
    lay: a => a.adset_name,
  },
  {
    khoa: 'ad_account_name',
    nhan: 'TKQC',
    mac_dinh: true,
    lay: a => a.ad_account_name,
  },
  {
    khoa: 'effective_status',
    nhan: 'TRANG_THAI_AD',
    mac_dinh: true,
    lay: a => a.effective_status,
  },
  {
    khoa: 'contact_count',
    kieu: 'so',
    nhan: 'SO_KHACH',
    mac_dinh: true,
    lay: a => a.contact_count,
  },
  {
    khoa: 'touch_count',
    kieu: 'so',
    nhan: 'SO_LAN_CHAM',
    mac_dinh: true,
    lay: a => a.touch_count,
  },
  {
    khoa: 'last_touch_at',
    kieu: 'so',
    nhan: 'LUC_BAM',
    mac_dinh: true,
    lay: a => gio(a.last_touch_at),
    layCsv: a => gioDay(a.last_touch_at),
  },
  {
    khoa: 'bm_id',
    kieu: 'id',
    nhan: 'BM_ID',
    mac_dinh: false,
    lay: a => a.bm_id,
  },
  {
    khoa: 'ad_account_id',
    kieu: 'id',
    nhan: 'TKQC_ID',
    mac_dinh: false,
    lay: a => a.ad_account_id,
  },
  {
    khoa: 'campaign_id',
    kieu: 'id',
    nhan: 'CAMP_ID',
    mac_dinh: false,
    lay: a => a.campaign_id,
  },
  {
    khoa: 'adset_id',
    kieu: 'id',
    nhan: 'ADSET_ID',
    mac_dinh: false,
    lay: a => a.adset_id,
  },
  {
    khoa: 'post_id',
    kieu: 'id',
    nhan: 'POST_ID',
    mac_dinh: false,
    lay: a => a.post_id,
  },
];

// --- Tab Inbox: một row = một tin nhắn -----------------------------------
export const COT_INBOX = [
  {
    khoa: 'created_at',
    kieu: 'so',
    nhan: 'LUC',
    mac_dinh: true,
    lay: m => gio(m.created_at),
    layCsv: m => gioDay(m.created_at),
  },
  {
    khoa: 'conversation_id',
    kieu: 'so',
    nhan: 'HOI_THOAI',
    mac_dinh: true,
    khoaLink: 'inbox',
    lay: m => m.conversation_id,
  },
  {
    khoa: 'contact_name',
    nhan: 'HO_TEN',
    mac_dinh: true,
    lay: m => m.contact_name,
  },
  {
    khoa: 'nguoi_gui',
    nhan: 'NGUOI_GUI',
    mac_dinh: true,
    lay: m => m.nguoi_gui,
  },
  { khoa: 'loai', nhan: 'HUONG', mac_dinh: true, lay: m => m.loai },
  {
    khoa: 'noi_dung',
    nhan: 'NOI_DUNG',
    mac_dinh: true,
    dai: true,
    lay: m => m.noi_dung,
  },
  {
    khoa: 'inbox_name',
    nhan: 'TRANG',
    mac_dinh: false,
    lay: m => m.inbox_name,
  },
];

// Cột CHỈ có trong file CSV, không hiện trên bảng. Bảng để đọc lướt nên phải
// gọn; file CSV mở bằng Excel thì thừa cột không sao, mà thiếu là phải nối tay
// với file khác.
const COT_CSV_THEM = [
  {
    khoa: 'campaign_name',
    nhan: 'CHIEN_DICH',
    lay: h => h.ads.campaign_name,
  },
  {
    khoa: 'campaign_id',
    kieu: 'id',
    nhan: 'CAMP_ID',
    lay: h => h.ads.campaign_id,
  },
  { khoa: 'adset_id', kieu: 'id', nhan: 'ADSET_ID', lay: h => h.ads.adset_id },
  {
    khoa: 'ad_account_name',
    nhan: 'TKQC',
    lay: h => h.ads.ad_account_name,
  },
  {
    khoa: 'ad_account_id',
    kieu: 'id',
    nhan: 'TKQC_ID',
    lay: h => h.ads.ad_account_id,
  },
  { khoa: 'bm_id', kieu: 'id', nhan: 'BM_ID', lay: h => h.ads.bm_id },
  { khoa: 'page_id', kieu: 'id', nhan: 'PAGE_ID', lay: h => h.ads.page_id },
  { khoa: 'post_id', kieu: 'id', nhan: 'POST_ID', lay: h => h.ads.post_id },
  { khoa: 'trang_thai', nhan: 'TRANG_THAI', lay: h => h.inbox.status },
  { khoa: 'phu_trach', nhan: 'PHU_TRACH', lay: h => h.inbox.assignee },
  {
    khoa: 'message_count',
    kieu: 'so',
    nhan: 'SO_TIN',
    lay: h => h.inbox.message_count,
  },
];

export const COT_THEO_TAB = { khach: COT_KHACH, ad: COT_AD, inbox: COT_INBOX };

// Tab Khách hàng xuất kèm cả cây quảng cáo; hai tab kia bảng đã đủ chi tiết.
export const COT_CSV_THEO_TAB = {
  khach: [...COT_KHACH, ...COT_CSV_THEM],
  ad: COT_AD,
  inbox: COT_INBOX,
};

// CSV xuất HẾT cột, kể cả cột đang tắt.
export const dungCsv = (cot, hangs, dich) => {
  const dong = gt => {
    const s = gt === null || gt === undefined ? '' : String(gt);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const dau = cot.map(c => dong(dich(c.nhan)));
  // `layCsv` cho cot ngay: file xuat ra giu du nam va giay, khac ban rut gon
  // tren bang.
  const than = hangs.map(h => cot.map(c => dong((c.layCsv || c.lay)(h))));
  // BOM để Excel trên Windows đọc đúng tiếng Việt.
  const bom = String.fromCharCode(0xfeff);
  return bom + [dau, ...than].map(r => r.join(',')).join('\n');
};
